import { ref, onMounted } from "vue";
import { templateRef } from "@vueuse/core";
import { useScrollTriggerAnimation } from "/composables/useScrollTriggerAnimation";
import { useUser } from "/composables/useUser";
import { useImageSources } from "/composables/useImageSources";


export default {
  __name: 'index',
  props: {
  dataProvider: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const tpl_mediaWrapper = templateRef("tpl_mediaWrapper");
const tpl_desc = templateRef("tpl_desc");
const tpl_mobileBtnWrapper = templateRef("tpl_mobileBtnWrapper");

const showModal = ref(false);
const { logged } = useUser();
const { reveal } = useScrollTriggerAnimation();
const { getSrc, getSrcset } = useImageSources();

const srcset = getSrcset(props.dataProvider.media.src, {
  sm: 1280,
  md: 1280,
  lg: 1280,
  xl: 1500,
  "2xl": 1500,
});

onMounted(() => {
  reveal(tpl_mediaWrapper.value.childNodes, tpl_mediaWrapper.value, "bottom", {
    intensity: "strong",
    fade: true,
    duration: "normal",
  });

  reveal(tpl_desc.value, tpl_desc.value, "right", {
    intensity: "strong",
    fade: true,
  });
});

return { __sfc: true,props, tpl_mediaWrapper, tpl_desc, tpl_mobileBtnWrapper, showModal, logged, reveal, getSrc, getSrcset, srcset }
}

}